// Play-Overlay ueber hochgeladenen Videos (shared/_media): ein Klick startet das Video, das
// Overlay verschwindet beim Abspielen und kommt am Ende zurueck. Ohne JavaScript bleiben die
// normalen Player-Bedienelemente nutzbar; das Overlay liegt nur ueber der Mitte.
document.addEventListener('initialize', function() {
  document.querySelectorAll('.media-video').forEach(function(container) {
    if (container.dataset.mediaPlayReady) { return; }
    container.dataset.mediaPlayReady = 'true';

    var video = container.querySelector('video');
    var overlay = container.querySelector('.media-play-overlay');
    if (!video || !overlay) { return; }

    overlay.addEventListener('click', function() { video.play(); });
    video.addEventListener('play', function() { overlay.hidden = true; });
    video.addEventListener('ended', function() { overlay.hidden = false; });
  });
});

// Turbo legt beim Verlassen einen Schnappschuss der Seite ab: Attribute bleiben, Listener nicht.
// Ohne diesen Schritt kaeme die Seite ueber "Zurueck" mit gesetztem Merker, aber ohne Bindung
// wieder - das Overlay klickte ins Leere (gleiches Muster wie tooltip.js).
document.addEventListener('turbo:before-cache', function() {
  document.querySelectorAll('.media-video').forEach(function(container) {
    delete container.dataset.mediaPlayReady;
    var overlay = container.querySelector('.media-play-overlay');
    if (overlay) { overlay.hidden = false; }
  });
});
